import { Component, Input, OnInit } from '@angular/core';
import { Color } from '../../../models/color';
import { Colorable } from '../../../models/colorable';
import { ColorPickerOptions } from '../../../../environments/configs/color-picker-options';
import { ColorPipe } from '../../../pipes/color.pipe';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    standalone: true,
    imports: [
        ColorPipe,
        NgStyle
    ]
})
export class ColorPickerComponent implements OnInit {

    @Input() text: string;
    @Input() colorable: Colorable;
    colors: Array<Color>;

    ngOnInit(): void {
        this.colors = ColorPickerOptions.colors;
    }

    setColor(color: Color): void {
        this.colorable.color = color;
    }

    getColor(): Color {
        return this.colorable.color;

    }
}
